module.exports = __webpack_public_path__ + "img/csgoimg.45357e82.png";